import { IAvailableBookingPeriod } from '@shared/integrations/taf-api/v2/models';
import { useEffect, useState } from 'react';
import {getDateRangesFromAvailableBookingPeriods} from "@my-pages/features/object-booking/utils/calendarUtils.ts";


const useGetAvailableDates = (data: IAvailableBookingPeriod[] | undefined) => {
    const [availableDates, setAvailableDates] = useState<Date[]>([]);

    useEffect(() => {
        if (!data) return;

        const availableDatesInMonth = getDateRangesFromAvailableBookingPeriods(data);
        setAvailableDates(availableDatesInMonth);
    }, [data]);

    return availableDates;
};
export default useGetAvailableDates;
